import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type NewsPost = {
  id: string;
  title: string;
  slug: string;
  content: string;
  excerpt: string;
  image_url: string;
  author?: string;
  author_image_url?: string;
  published_at: string;
  created_at: string;
  category?: string;
  tags?: string[];
  is_featured?: boolean;
  download_links?: any[];
};

export type Project = {
  id: string;
  title: string;
  description: string;
  image_url: string;
  order_index: number;
  created_at: string;
};

export type PodcastApplication = {
  id: string;
  first_name: string;
  last_name: string;
  alias: string;
  email: string;
  english_speaking: boolean;
  project_link: string;
  about_you: string;
  about_project: string;
  name?: string;
  pitch?: string;
  status: string;
  created_at: string;
};

export type SocialLink = {
  id: string;
  label: string;
  url: string;
  icon: string;
  order_index: number;
};

export type CarouselSlide = {
  id: string;
  title: string;
  subtitle: string;
  image_url: string;
  link_url: string;
  link_text: string;
  order_index: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
};

export type Episode = {
  id: string;
  slug: string;
  podcast_number: string | null;
  title: string;
  summary: string | null;
  description: string | null;
  guests: string | null;
  keywords: string[] | null;
  game_project: string | null;
  game_link: string | null;
  youtube_link: string | null;
  youtube_embed: string | null;
  blog_youtube_summary: string | null;
  carousel_slide_1080: string | null;
  youtube_thumbnail_1080p: string | null;
  game_thumbnail_460x215: string | null;
  screenshot_1_600x338: string | null;
  screenshot_2_600x338: string | null;
  screenshot_3_600x338: string | null;
  storage_bucket: string | null;
  storage_root: string;
  manifest: any | null;
  created_at: string;
  updated_at: string;
};
